import React, { Component } from 'react';
import Select from 'react-select';

var stringUtil = require('../../utils/string/stringUtil');

class SelectComponent extends Component 
{
    constructor(props) 
    {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(selectedValue)
    {
        if (!this.props.onSelectionChanged)
            return;

        if (!this.props.multi)
        {
            let selectedOption = null;
            if (selectedValue)
            {
                selectedOption = selectedValue.underlyingObject;
            }
            this.props.onSelectionChanged(selectedOption);
            return;
        }

        var results = [];
        if (selectedValue != null)
        {
            selectedValue.forEach (v =>
            {
                results.push(v.underlyingObject);
            });
        }

        this.props.onSelectionChanged(results);
    }

    getOptions()
    {
        const result = [];

        const options = this.props.options || null;

        if (Array.isArray(options) && options.length > 0)
        {
            const displayFieldName = this.props.displayFieldName;
            const valueFieldName = this.props.valueFieldName;

            options.forEach(option => 
            {
                result.push(
                    {
                        label: option[displayFieldName],
                        value: option[valueFieldName],
                        underlyingObject: option,
                        disabled: option.disabled
                    });
            });
        }

        return result;
    }

    getValue()
    {
        if (!this.props.multi)
        {
            if (stringUtil.isStringNullOrEmpty(this.props.selectedValue))
                return null;

            return this.getOptions().find(o => stringUtil.areStringSame(this.props.selectedValue, o.underlyingObject[this.props.valueFieldName]));
        }
        else
        {
            var values = [];
            if (this.props.selectedValue != null )
                values = this.props.selectedValue;

            return this.getOptions().filter(o => values.some(v => stringUtil.areStringSame(v, o.value)));
        }
    }

    render()
    {
        const styles = {
            menu: (base) => ({
              ...base,
              marginTop: "0px"
            })
          };

        return <div>
                    <div>{this.props.getCaption()}</div>
                    <div style={{marginTop:'5px'}}>
                        <Select
                            id={this.props.valueFieldName}
                            options={this.getOptions()}
                            value={this.getValue()}
                            onChange={this.onChange}
                            isMulti={this.props.multi}
                            isClearable={this.props.isClearable}
                            isSearchable={false}
                            styles={styles}
                        />
                    </div>
                    <div className='hint-text' style={{marginLeft:'5px', marginTop:'5px'}}>{this.props.getHints()}</div>
                </div>
    }
}

export default SelectComponent;